import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { getClassName } from "./const";
import "./CostIndexValue.scss";

export const CostIndexValue = ({ value = "" }) => {
  return (
    <div className={classNames("cost-index-value", getClassName(value))}>
      {value}
    </div>
  );
};

CostIndexValue.propTypes = {
  value: PropTypes.any,
};
